import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Tu configuración de Firebase - reemplaza con tus credenciales reales
const firebaseConfig = {
  apiKey: "AIzaSyDTE-wTBibLzmaNe_IpOCgY5nzOrn9h68o",
  authDomain: "tecnologiabg.firebaseapp.com",
  databaseURL: "https://tecnologiabg-default-rtdb.firebaseio.com",
  projectId: "tecnologiabg",
  storageBucket: "tecnologiabg.firebasestorage.app",
  messagingSenderId: "26386990417",
  appId: "1:26386990417:web:7e5c2f398b9cfab5783f70"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
